<template>
  <section>
    <dialogModule
      top="10"
      width="520px"
      title="已核销券"
      v-if="ticketVisible"
      :close-on-press-escape="false"
      :dialogVisible="ticketVisible"
      @close="close">
      <span slot="close" class="el-icon-close close cursor" @click="close"></span>
      <div slot="content" v-loading="queryLoading">
        <div class="goods-card" v-for="(item, i) in ticketInfoList" :key="i">
          <div class="row align-center title-box">
            <span>{{item.couponTypeName}}</span>
            <p class="row align-center">
              <img v-if="item.channel === '1'" src="@/assets/images/douyin.png" />
              <img v-if="item.channel === '2'" src="@/assets/images/kuaishou.png" />
              <img v-if="item.channel === '3'" src="@/assets/images/wxchat.png" />
              {{item.channelName}}
            </p>
            <div>{{item.name}}</div>
          </div>
          <div class="row align-center space-between goods-box">
            <div class="goods-all row align-center">
              <template v-if="item.goodInfos">
                <div v-for="(goods, g) in item.goodInfos" :key="g + goods.goodsNo" class="goods-item">
                  <div class="goods-img">
                    <el-image class="img" v-if="goods.imageList && goods.imageList.length" :src="goods.imageList[0]" :preview-src-list="goods.imageList"></el-image>
                    <div class="def-img row align-center space-center" v-else>暂无图片</div>
                    <div class="num">{{goods.number}}件</div>
                  </div>
                  <div class="goods-spu">{{goods.goodsNo}}</div>
                </div>
              </template>
              <template v-if="item.giftGoodInfos">
                <div v-for="(goods, a) in item.giftGoodInfos" :key="a" class="goods-item">
                  <div class="goods-img">
                    <el-image class="img" v-if="goods.imageList && goods.imageList.length" :src="goods.imageList[0]" :preview-src-list="goods.imageList"></el-image>
                    <div class="def-img row align-center space-center" v-else>暂无图片</div>
                    <div class="num">{{goods.number}}件</div>
                    <div class="label">赠品</div>
                  </div>
                  <div class="goods-spu">{{goods.goodsNo}}</div>
                </div>
              </template>
            </div>
            <div
              v-if="(item.goodInfos && item.goodInfos.length) || (item.giftGoodInfos && item.giftGoodInfos.length)"
              class="total"
              @click="showTotal(item)">
              共{{(item.goodInfos && item.goodInfos.length || 0) + (item.giftGoodInfos && item.giftGoodInfos.length || 0)}}款<i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="row align-center price-box">
            <p v-if="![0, 3].includes(item.couponType) && (item.tagPrice || item.retailPrice)">{{ item.couponType === 1 ? '吊牌价' : '原价' }}：<span>{{item.couponType === 1 ? item.tagPrice : item.retailPrice}}</span></p>
            <p v-if="item.tagDiscountAmount || item.actualDiscountAmount">{{item.couponType === 1 ? '吊牌优惠' : '优惠'}}：<span>减{{item.couponType === 1 ? item.tagDiscountAmount : item.actualDiscountAmount}}</span></p>
            <p v-if="![0, 3].includes(item.couponType)">
              <template v-if="Number(item.realPrice) > 0">需补差：<span>{{item.realPrice}}</span></template>
              <span v-else style="color: #F8475F;font-weight: normal;">差额不退</span>
            </p>
          </div>
          <div class="row align-center space-end btn-box">
            <div class="gift" v-if="item.isHaveGift === 'Y'" @click="chooseGift(item)">选择赠品</div>
            <div class="choose" v-if="item.isReSelect === 'Y'" @click="selectCheckType(item, i)">重选核销方式</div>
            <div class="choose" v-if="![0, 3].includes(item.couponType)" @click="reChoose(item)">重选货品</div>
            <el-button class="back" :loading="queryLoading" @click="backOut(item)">撤销核销</el-button>
          </div>
        </div>
      </div>
    </dialogModule>
    <TicketGive v-if="giveVisible" :couponInfo="currentTicket" :couponInfoList="ticketInfoList" @close="giveVisible = false" @operate="giftBack"></TicketGive>
    <TicketGoods v-if="detailVisible" :currentTicket="currentTicket" @close="detailVisible = false"></TicketGoods>
  </section>
</template>

<script>
import eventBus from '@/bus/index.js'
import TicketGive from "./TicketGive.vue"
import TicketGoods from "./TicketGoods.vue"
import dialogModule from "@/components/dialogModule.vue"
import {operateGoodsNo} from "@/libs/http/modules/posOrder";
export default {
  components: {
    TicketGive,
    TicketGoods,
    dialogModule
  },
  props: {
    goodsList: {
      type: Array,
      default: () => []
    },
    couponInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return{
      giveVisible: false,
      ticketVisible: true,
      detailVisible: false,
      currentTicket: null,
      ticketInfoList: [],
      queryLoading: false
    }
  },
  beforeDestroy(){
    eventBus.$off('send')
  },
  created() {
    this.ticketInfoList = this.couponInfoList
    eventBus.$on('send', list => {
      this.ticketInfoList = list
    })
  },
  methods: {
    close(){
      if(this.queryLoading) return //接口未响应时不允许点"x"关闭弹窗
      this.ticketVisible = false
      this.$emit('close')
    },
    showTotal(item){
      this.currentTicket = item
      this.detailVisible = true
    },
    chooseGift(item){
      this.currentTicket = item
      this.giveVisible = true
    },
    selectCheckType(item, i){
      console.log(item)
      this.$emit('changeType', {
        ...item,
        couponIndex: i
      })
    },
    giftBack(e){
      let index = this.ticketInfoList.findIndex(item=>{
        return item.certificateId === e.certificateId
      })
      this.ticketInfoList.splice(index, 1, e)
      this.unifyAction(e.certificateId, '4')
    },
    reChoose(item){
      this.$emit('re', item)
    },
    backOut(item){
      this.$confirm('确定撤销核销？', '撤销提示').then(res => {
        this.unifyAction(item.certificateId, '5')
      }).catch(() => {})
    },

    unifyAction(ticketId, type){
      this.queryLoading = true
      let params = {
        type: '6',
        couponInfoList: this.ticketInfoList,
        operateCouponsGoodInfo: {
          certificateId: ticketId,
          operationCouponType: type
        }
      }
      if(this.goodsList.length){
        params['goodInfos'] = this.goodsList
      }
      operateGoodsNo(params).then(res=>{
        this.queryLoading = false
        this.ticketInfoList = res.couponGoodInfos
        if(!this.ticketInfoList.length){
          this.close()
        }
        this.$emit('update', res)
      }).catch(error=>{
        this.queryLoading = false
        this.$message({showClose: true, message: error, type: "error", duration: 2000})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-card{
  margin: 20px;
  border-bottom: 1px solid #eee;
  &:last-child{
    border-bottom: none;
  }
  .title-box{
    margin-bottom: 10px;
    >span{
      font-size: 18px;
      padding: 2px 5px;
      margin-right: 10px;
      border-radius: 4px;
      font-weight: bolder;
      color: #722ED1;
    }
    p{
      font-size: 13px;
      img{
        width: 15px;
        margin-right: 5px;
        border-radius: 4px;
      }
    }
    div{
      flex: 1;
      color: #000;
      font-size: 14px;
      overflow: hidden;
      margin-left: 15px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .goods-box{
    margin-bottom: 10px;
    .goods-all{
      flex: 1;
      overflow: hidden;
      .goods-item{
        margin-right: 10px;
        border-radius: 4px;
        .goods-img{
          width: 90px;
          height: 90px;
          overflow: hidden;
          position: relative;
          .img{
            width: 90px;
            height: 90px;
            margin-bottom: 5px;
            border-radius: 4px;
          }
          .def-img{
            width: 90px;
            height: 90px;
            background: #eee;
            margin-bottom: 5px;
            border-radius: 4px;
          }
          .num{
            bottom: 0;
            left: 2px;
            color: #fff;
            padding: 0 2px;
            font-size: 12px;
            background: #aaa;
            position: absolute;
            border-radius: 2px;
          }
          .label {
            top: 5px;
            color: #fff;
            width: 60px;
            right: -15px;
            height: 20px;
            font-size: 12px;
            position: absolute;
            text-align: center;
            transform: rotate(45deg);
            background: linear-gradient(0deg, #208aec, #02d7f0, #00c6f7);
          }
        }
        .goods-spu{
          color: #000;
        }
      }
    }
    .total{
      color: #000;
      width: 60px;
      cursor: pointer;
      text-align: right;
    }
  }
  .price-box{
    p{
      color: #000;
      margin-right: 30px;
      span{
        color: #000;
        font-weight: bold;
      }
    }
  }
  .btn-box{
    padding: 15px 0;
    div{
      height: 32px;
      padding: 0 10px;
      cursor: pointer;
      line-height: 32px;
      text-align: center;
      border-radius: 4px;
      margin-right: 10px;
    }
    .gift{
      color: #067CF2;
      background: #E6F7FF;
      border: 1px solid #067CF2;
    }
    .choose{
      color: #fff;
      background: #067CF2;
    }
    .back{
      padding: 0;
      color: #fff;
      width: 80px;
      height: 34px;
      line-height: 34px;
      background: #F8475F;
    }
  }
}
</style>